import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { CutVersionService } from './app/common/cut-version/cut-version.service';
import { environment } from './environments/environment';


CutVersionService.monkeyPatchingAddEventListener();

if (environment.production) {
	enableProdMode();
}

const bootstrap = () => platformBrowserDynamic()
	.bootstrapModule(AppModule, {applicationProviders: [provideZoneChangeDetection()]});


bootstrap();
// if (environment.hmr) {
// 	if (module['hot']) {
// 		hmrBootstrap(module, bootstrap);
// 	} else {
// 		console.error('HMR is not enabled for webpack-dev-server!');
// 		// eslint-disable-next-line
// 		console.log('Are you using the --hmr flag for ng serve?');
// 	}
// } else {
// 	bootstrap();
// }
